module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_9005.6fc3a1b7.png";